import { useQuery } from "@apollo/client";

import { IReaction } from "MVVM/@types";
import { CLIP_OF_THE_DAY } from "../../../GraphQL/clipOfTheDay";
import { IFeaturedItem } from "../Featured/@types";
import { IProPlayerInfo, ITag } from "./@types";
import { parseProPlayer } from "./parseProPlayer";

interface IClipUser {
  avatarUrl: string;
  username: string;
  internalId: string;
}

interface IClipOfTheDay {
  id: string;
  internalId: string;
  shareId: string;
  title: string;
  thumbnailUrl?: string;
  url: string;
  views?: number;
  createdAt?: string;
  playerGameIdentifier?: string;
  reactions?: IReaction[] | null;
  comments?: { pageInfo?: { totalCount?: number } } | null;
  user?: IClipUser | null;
  tags?: ITag[] | null;
}

const ClipOfTheDayViewModel = () => {
  const { data, error, loading } = useQuery(CLIP_OF_THE_DAY, {
    fetchPolicy: "network-only",
    errorPolicy: "all",
  });

  const clip: IClipOfTheDay | null = data?.clipOfTheDayNew ?? null;

  const clipOfTheDay: IFeaturedItem | null = clip
    ? {
        id: clip.id,
        internalId: clip.internalId,
        shareId: clip.shareId,
        title: clip.title,
        thumbnailUrl: clip.thumbnailUrl,
        url: clip.url,
        views: clip.views,
        createdAt: clip.createdAt,
        reactions: clip.reactions ?? [],
        likeCount: (clip.reactions ?? []).reduce((sum, r) => sum + r.count, 0),
        commentCount: clip.comments?.pageInfo?.totalCount ?? 0,
        ...(clip.user && {
          avatar: clip.user.avatarUrl,
          username: clip.user.username,
          userId: clip.user.internalId,
        }),
        link: `/clip/${clip.shareId}`,
        type: "cotd",
        tag: "WATCH",
        buttonCopy: "Watch",
      }
    : null;

  const parsedProPlayer = clip ? parseProPlayer(clip.tags) : null;
  const proPlayer: IProPlayerInfo | null = parsedProPlayer
    ? { ...parsedProPlayer, playerGameIdentifier: clip?.playerGameIdentifier }
    : null;

  const tags: ITag[] = clip?.tags ?? [];

  return { clipOfTheDay, proPlayer, tags, error, loading };
};

export { ClipOfTheDayViewModel };
